type HealthScoreIndicatorProps = {
  score: number | null
}

export function HealthScoreIndicator({ score }: HealthScoreIndicatorProps) {
  if (score === null) {
    return <span className="text-xs text-body-secondary">-</span>
  }

  const getVariantClass = (score: number): string => {
    if (score >= 90) return "health-score-indicator--excellent"
    if (score >= 70) return "health-score-indicator--healthy"
    if (score >= 50) return "health-score-indicator--at-risk"
    return "health-score-indicator--critical"
  }

  return (
    <div className="d-flex gap-2 align-items-center">
      <div className={`health-score-indicator ${getVariantClass(score)}`}>
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="health-score-indicator__bar" />
        ))}
      </div>
      <div className="text-sm">{score}</div>
    </div>
  )
}
